import React, { Component } from "react";
import { connect } from 'react-redux';

import PageSection from "../../modules/PageSection";

import * as serviceActions from "../../../actions/services";

import styles from './styles.scss';

class ServiceSection extends Component {
    componentDidMount() {
        this.props.refreshServiceReferrer(this.props.serviceId);
    }

    render() {
        if (!this.props.serviceReferrer) return null;

        return (
            <PageSection>
                <a className={styles['logo-container']} href={this.props.serviceReferrer.service_url}>
                    <img alt={`Go to ${this.props.serviceReferrer.name}`} className={styles['service-logo']} src={this.props.serviceReferrer.logo_url} />
                </a>
            </PageSection>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.services
    }
};

const mapDispatchToProps = dispatch => {
    return {
        refreshServiceReferrer(serviceId) {
            return dispatch(serviceActions.refreshServiceReferrer(serviceId));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceSection);

